import loadable, { LoadableLibrary } from '@loadable/component';
import InteriorDesignServiceMicroFrontend from 'Client/components/MicroFrontend/InteriorDesignService';
import WishlistMicroFrontend from 'Client/components/MicroFrontend/Wishlist';
import CartMicroFrontend from 'Client/components/MicroFrontend/Cart';
import HalloWeltMicroFrontend from 'Client/components/MicroFrontend/HalloWelt';
import paths from 'Common/routes/paths';
import CheckoutMicroFrontend from 'Client/components/MicroFrontend/Checkout';
import NotFound from 'Client/components/NotFound';

const ServicePage = loadable(() => import('Client/components/ServicePage/Home'));
const Homepage = loadable(() => import('Client/components/Homepage/index'));
const LandingPageRedirect = loadable(() => import('Client/components/Redirects/LandingPageRedirect'));
const ListingPage = loadable(() => import('Client/components/ListingPage/index'));
const ProductDetailPage = loadable(() => import('Client/components/ProductDetailPage/index'));
const Looks = loadable(() => import('Client/components/Looks/index'));
const UnsupportedBrowser = loadable(() => import('Client/components/UnsupportedBrowser'));
const AssemblyServiceAppOverlay = loadable(
    () => import('Client/components/ProductDetailPage/AssemblyService/AssemblyServiceAppOverlay')
);

export interface RouteInterface {
    path: string | string[];
    code: number;
    exact: boolean;
    component: LoadableLibrary<any>;
    slug?: string;
}

const routes: Array<RouteInterface> = [
    {
        path: ['/', '/index', '/index/index'],
        code: 200,
        exact: true,
        component: Homepage,
        slug: '',
    },
    {
        path: paths.SERVICE_PAGE,
        code: 200,
        exact: true,
        component: ServicePage,
        slug: '',
    },
    {
        path: paths.LOOKS,
        code: 200,
        exact: false,
        component: Looks,
        slug: '',
    },
    {
        path: [paths.WISHLIST, paths.WISHLIST_NATIVE],
        code: 200,
        exact: false,
        component: WishlistMicroFrontend,
        slug: '',
    },
    {
        path: paths.ASSEMBLYSERVICE,
        code: 200,
        exact: false,
        component: AssemblyServiceAppOverlay,
        slug: '',
    },
    {
        path: paths.HALLO_WELT,
        code: 200,
        exact: false,
        component: HalloWeltMicroFrontend,
        slug: '',
    },
    {
        path: [paths.INTERIOR_DESIGN_SERVICE, paths.INTERIOR_DESIGN_SERVICE_NATIVE, paths.INTERIOR_DESIGN_SERVICE_OLD],
        code: 200,
        exact: false,
        component: InteriorDesignServiceMicroFrontend,
        slug: '',
    },
    {
        path: [paths.CART, paths.CART_NATIVE],
        code: 200,
        exact: true,
        component: CartMicroFrontend,
    },
    {
        path: [paths.CHECKOUT, paths.CHECKOUT_NATIVE],
        code: 200,
        exact: false,
        component: CheckoutMicroFrontend,
    },
    {
        path: paths.UNSUPPORTED_BROWSER,
        code: 200,
        exact: true,
        component: UnsupportedBrowser,
    },
    {
        path: paths.OOPS_PAGE,
        exact: true,
        code: 500,
        component: NotFound,
    },
    {
        path: '/*.html',
        code: 200,
        exact: true,
        component: ProductDetailPage,
        slug: '',
    },
    {
        path: '/landing/:listingPageKey',
        code: 200,
        exact: false,
        component: LandingPageRedirect,
        slug: '',
    },
    {
        path: '/:listingPageKey',
        exact: false,
        code: 200,
        component: ListingPage,
    },
];

export default routes;
